import { render, staticRenderFns } from "./TopicDynamic.vue?vue&type=template&id=56a89872&scoped=true"
import script from "./TopicDynamic.vue?vue&type=script&lang=js"
export * from "./TopicDynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a89872",
  null
  
)

export default component.exports